module.exports = __webpack_public_path__ + "f50fdb8c220224c682ca8d38c63423d3.svg";